import { DataBean } from "../DataBean";

export class CreditStructure extends DataBean {

  public async creditStrucutreConstants(arg: number): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "java.util.List_creditStrucutreConstants_Number",
      [arg]
    );
  }

  public async createCreditStructure(idEmployee: number, typeStructure: number, data: any, observation: string): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "com.credit.bean.CreditAccount_createCreditStructure_Number_Number_java.util.Map_String",
      [idEmployee, typeStructure, data, observation]
    );
  }

  public async getCreditStructureRender(page: number, rows: number, props: any): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "com.advantage.shared.Report_getCreditStructureRender_Number_Number_java.util.Map",
      [page, rows, props]
    );
  }


}
